import React from 'react';

import { Skeleton } from '@repo/ui/components/ui/skeleton';

export const KeyTakeawaysSectionSkeleton: React.FC = () => {
  return (
    <div className="space-y-3">
      <div className="flex w-full justify-between px-3">
        <Skeleton className="h-4.5 w-full rounded-md bg-[#2D3748]" />
      </div>
      <div className="px-3">
        <Skeleton className="h-37.25 w-full rounded-md bg-[#2D3748]" />
      </div>
    </div>
  );
};
